import DashboardQuickActions from "../components/DashboardQuickActions";
import { Text, AIAssistant } from "../../../core";
import { useAppSelector } from "@packages/store/hooks";
import DashboardMainOnboarding from "../components/DashboardMainOnboarding";

const DashboardPageView = () => {
  const teacherName = useAppSelector((state) => state.user.teacher?.name);

  return (
    <div className="flex-1 md:p-8 p-4 lg:mt-5 bg-gray-50 dark:bg-dark-500 lg:rounded-tl-3xl overflow-y-auto h-full custom-scrollbar">
      <DashboardMainOnboarding />
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 flex flex-col gap-2 items-start">
          <Text variant="h1" values={{ name: teacherName }}>
            welcome
          </Text>
          <Text variant="h3" className="text-gray-500 dark:text-gray-400">
            dashboard.madlen_time_saver
          </Text>
        </div>

        <div className="mb-8">
          {/* AI Assistant */}
          <AIAssistant />
        </div>

        <DashboardQuickActions />
      </div>
    </div>
  );
};

/*
// Earnings Analysis - Temporarily Commented Out
// To restore, uncomment the following imports and code:

// import { useTranslation } from "react-i18next";
// import {
//   useGetTeacherMinuteSaved,
//   useGetTeachersMinuteSaved,
// } from "@packages/api/madlenAPI";
// import { useMemo } from "react";

// Add these to the component:
// const { t } = useTranslation();
// const { data: teacherMinuteSaved, isLoading: isTeacherLoading } = useGetTeacherMinuteSaved();
// const { data: globalMinuteSaved, isLoading: isGlobalLoading } = useGetTeachersMinuteSaved();
// 
// const formatMinutesToTimeString = (minutes: number | undefined) => {
//   if (!minutes || minutes === 0) return undefined;
//   if (minutes < 60) {
//     return `${minutes} ${t("common.time.minutes")}`;
//   }
//   const hours = Math.ceil(minutes / 60);
//   return `${hours} ${t("common.time.hours")}`;
// };
//
// const formattedTeacherTimeSaved = useMemo(
//   () => formatMinutesToTimeString(teacherMinuteSaved?.minutesSaved),
//   [teacherMinuteSaved],
// );
//
// const formattedGlobalTimeSaved = useMemo(
//   () => formatMinutesToTimeString(globalMinuteSaved?.minutesSaved),
//   [globalMinuteSaved],
// );
//
// const hasTeacherMinutes = teacherMinuteSaved?.minutesSaved !== undefined && teacherMinuteSaved.minutesSaved > 0;
// const hasGlobalMinutes = globalMinuteSaved?.minutesSaved !== undefined && globalMinuteSaved.minutesSaved > 0;
// const isLoading = isTeacherLoading || isGlobalLoading;

// Replace the AIAssistant with this JSX:
//        <div className="mb-8">
//          <div className="bg-white dark:bg-black rounded-3xl border border-dark-400 dark:border-dark-400 overflow-hidden shadow-2xl shadow-gray-200/20 dark:shadow-black/40">
//            <div className="bg-gray-50 dark:bg-dark-600 px-6 py-4 border-b border-gray-100 dark:border-dark-400">
//              <div className="flex items-center justify-between">
//                <div className="flex items-center gap-3">
//                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
//                  <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
//                    {t("dashboard.earnings_analysis")}
//                  </h2>
//                </div>
//                <div className="flex items-center gap-2">
//                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
//                  <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">
//                    {t("dashboard.active")}
//                  </span>
//                </div>
//              </div>
//            </div>
//            <div className="p-6 lg:p-8">
//              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                <div className="group relative">
//                  <div className="absolute"></div>
//                  <div className="relative bg-gray-50 dark:bg-dark-600 rounded-2xl p-6 h-full">
//                    {isLoading ? (
//                      <div className="space-y-4">
//                        <div className="flex items-start justify-between mb-4">
//                          <div className="h-6 w-16 bg-gray-300 dark:bg-gray-600 rounded-lg animate-pulse"></div>
//                        </div>
//                        <div className="space-y-3">
//                          <div className="h-4 w-32 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
//                          <div className="h-12 w-24 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
//                          <div className="h-4 w-40 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
//                        </div>
//                      </div>
//                    ) : (
//                      <>
//                        <div className="flex items-start justify-between mb-4">
//                          <div className="text-xs text-gray-400 dark:text-gray-300 bg-gray-200 dark:bg-dark-400 px-2 py-1 rounded-lg">
//                            {t("dashboard.personal")}
//                          </div>
//                        </div>
//                        <div className="space-y-2">
//                          <h3 className="text-sm font-medium text-gray-600 dark:text-gray-300">
//                            {t("dashboard.time_saved")}
//                          </h3>
//                          {hasTeacherMinutes ? (
//                            <>
//                              <div className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">
//                                {formattedTeacherTimeSaved}
//                              </div>
//                              <p className="text-sm text-gray-500 dark:text-gray-400">
//                                {t("dashboard.total_savings_this_month")}
//                              </p>
//                            </>
//                          ) : (
//                            <>
//                              <div className="text-3xl lg:text-4xl font-bold text-gray-400 dark:text-gray-600">
//                                0 {t("common.time.minutes")}
//                              </div>
//                              <p className="text-sm text-gray-500 dark:text-gray-400">
//                                {t("dashboard.no_savings_yet")}
//                              </p>
//                            </>
//                          )}
//                        </div>
//                      </>
//                    )}
//                  </div>
//                </div>
//                <div className="group relative">
//                  <div className="absolute"></div>
//                  <div className="relative bg-gray-50 dark:bg-dark-600 rounded-2xl p-6 h-full">
//                    {isLoading ? (
//                      <div className="space-y-4">
//                        <div className="flex items-start justify-between mb-4">
//                          <div className="h-6 w-16 bg-gray-300 dark:bg-gray-600 rounded-lg animate-pulse"></div>
//                        </div>
//                        <div className="space-y-3">
//                          <div className="h-4 w-32 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
//                          <div className="h-12 w-24 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
//                          <div className="h-4 w-40 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
//                        </div>
//                      </div>
//                    ) : (
//                      <>
//                        <div className="flex items-start justify-between mb-4">
//                          <div className="text-xs text-gray-400 dark:text-gray-300 bg-gray-200 dark:bg-dark-400 px-2 py-1 rounded-lg">
//                            {t("dashboard.community")}
//                          </div>
//                        </div>
//                        <div className="space-y-2">
//                          <h3 className="text-sm font-medium text-gray-600 dark:text-gray-300">
//                            {t("dashboard.global_savings")}
//                          </h3>
//                          {hasGlobalMinutes ? (
//                            <>
//                              <div className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white">
//                                {formattedGlobalTimeSaved}
//                              </div>
//                              <p className="text-sm text-gray-500 dark:text-gray-400">
//                                {t("dashboard.all_teachers_total")}
//                              </p>
//                            </>
//                          ) : (
//                            <>
//                              <div className="text-3xl lg:text-4xl font-bold text-gray-400 dark:text-gray-600">
//                                0 {t("common.time.minutes")}
//                              </div>
//                              <p className="text-sm text-gray-500 dark:text-gray-400">
//                                {t("dashboard.no_data_available")}
//                              </p>
//                            </>
//                          )}
//                        </div>
//                      </>
//                    )}
//                  </div>
//                </div>
//              </div>
//            </div>
//          </div>
//        </div>
*/

export default DashboardPageView;
